import {CreatePlanNode, ToggleAllProcessor} from "../view-model";
import {cloneHierarchy} from "./cloneHierarchy";

const processNode = (node: CreatePlanNode, selected: boolean): boolean => {
  let updated = false;
  // Rule 1: Immutable nodes cannot be toggled
  if (!node.immutable) {
    if (node.selected !== selected) {
      node.selected = selected;
      updated = true;
    }
  }
  node.children.forEach(child => {
    if (processNode(child, selected)) {
      updated = true;
    }
  });
  return updated;
};

/**
 * Toggles all non-immutable children of a node in the hierarchy.
 * Returns the modified hierarchy if changes were made, otherwise undefined.
 *
 * @param root The root of the hierarchy
 * @param selected The selected state to set for the children
 * @returns The modified hierarchy if changes were made, otherwise undefined
 */
export const toggleAllSelection: ToggleAllProcessor = (
  root: CreatePlanNode,
  selected: boolean
): CreatePlanNode | undefined => {
  // Clone the plan to avoid modifying the original
  const clone = cloneHierarchy(root);
  return processNode(clone, selected) ? clone : undefined;
};
